var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#989DAF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.889 2.667H2.11A2.114 2.114 0 0 0 0 4.779V27.22c0 1.165.947 2.112 2.111 2.112H29.89A2.114 2.114 0 0 0 32 27.221V4.78a2.114 2.114 0 0 0-2.111-2.112zM2.11 4.477H29.89c.163 0 .301.138.301.302v15.39l-4.838-6.212a1.924 1.924 0 0 0-1.442-.758 1.923 1.923 0 0 0-1.494.65l-6.278 6.941c-.15.167-.486.213-.677.093L10.3 17.631c-.884-.557-2.179-.5-3.01.133l-5.48 4.172V4.779c0-.164.139-.302.302-.302zM29.89 27.523H2.11a.306.306 0 0 1-.301-.302v-3.01l6.574-5.006c.229-.174.709-.195.951-.042l5.162 3.252c.933.588 2.243.408 2.983-.41l6.278-6.942c.038-.041.065-.054.086-.055.015 0 .046.017.08.062l6.266 8.045v4.106a.306.306 0 0 1-.301.302z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.372 16.256a3.21 3.21 0 0 0 3.205-3.206 3.21 3.21 0 0 0-3.205-3.207 3.21 3.21 0 0 0-3.205 3.207 3.21 3.21 0 0 0 3.205 3.206zm0-4.603a1.397 1.397 0 0 1 0 2.792 1.397 1.397 0 0 1 0-2.792z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.a260bba7eda5161069673f241f105502.svg";
export { ForwardRef as ReactComponent };